import { TooltipProps } from "recharts";
import { ValueType, NameType } from "recharts/types/component/DefaultTooltipContent";
import styled from "styled-components";

const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>): JSX.Element => {
    
    if (active) {
        return (
            <Container>
                <div style={{"fontWeight": "bold"}}>{`Heure: ${label}`}</div>
                <div>{`Score: ${payload?.[0].value}`}</div>
            </Container>
        );
    }

    return <></>;
}

const Container = styled.div`
    background-color: white;
    border: solid black 2px;
    border-radius: 5px;
    padding: .5em;
`

export default CustomTooltip;